import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderEmptyTrashBinDialog = () => openPopupHelper({ popupName: popupNames.CLEAR_TRASHBIN });
